export default {
  vat: 'P.IVA e C.F. IT04565080266',
}
